import React from 'react';

/**
 * Metoda pro přenačtení dat v autocomplete (pro případy kdy v nich proběhly změny)

 * @param setEditedValues
 * @param ids
 * @param getItemsByIds
 */
export const refreshItems = async <ITEM>(
  setEditedValues: React.Dispatch<React.SetStateAction<ITEM[]>>,
  ids: (number | string)[],
  getItemsByIds?: (ids: (number | string)[]) => Promise<ITEM[]>
) => {
  if (getItemsByIds) {
    if (ids?.length > 0) {
      const data = await getItemsByIds(ids);
      setEditedValues(data);
    }
  }
};
